(function () {
  function easeOut(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function setFill(el, value) {
    if (!el) return;
    var w = value + '%';
    el.style.setProperty('--vb-fill', w);
    el.style.width = w;
    el.style.maxWidth = w;
  }

  function animateCircle(root, target) {
    var arc = root.querySelector('[data-vb-diff-arc]');
    var num = root.querySelector('[data-vb-diff-num]');
    if (!arc || !num || root.dataset.vbDiffStarted === '1') return;
    root.dataset.vbDiffStarted = '1';

    var circumference = 2 * Math.PI * 90;
    var duration = 1800;
    var start = performance.now();

    function frame(now) {
      var progress = Math.min((now - start) / duration, 1);
      var current = easeOut(progress) * target;
      arc.style.strokeDashoffset = String(circumference - (current / 100) * circumference);
      num.textContent = current.toFixed(1) + '%';
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function animateFill(el) {
    if (!el || el.dataset.vbDiffFillStarted === '1') return;
    el.dataset.vbDiffFillStarted = '1';
    var target = parseFloat(el.getAttribute('data-vb-diff-fill-target') || '0');
    if (isNaN(target)) target = 0;

    setFill(el, 0);

    var duration = 1400;
    var start = performance.now();

    function frame(now) {
      var progress = Math.min((now - start) / duration, 1);
      var current = easeOut(progress) * target;
      setFill(el, current);
      if (progress < 1) requestAnimationFrame(frame);
      else setFill(el, target);
    }

    requestAnimationFrame(frame);
  }

  function observe(section) {
    var circles = section.querySelectorAll('[data-vb-diff-circle]');
    var fills = section.querySelectorAll('[data-vb-diff-fill]');

    function run() {
      circles.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-vb-diff-target') || '0');
        animateCircle(el, isNaN(target) ? 0 : target);
      });
      fills.forEach(animateFill);
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            run();
            obs.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(section);
  }

  function init(section) {
    observe(section);
  }

  function boot() {
    document.querySelectorAll('[data-vb-pdp-different]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-vb-pdp-different]');
    if (section) init(section);
  });
})();
